import React, { Component } from 'react';
import "../custom.css";
import "../playerAssign.css"
import "bootstrap/dist/css/bootstrap.css";
import MvpAssignmentTable from "./MvpAssignmentTable";
import Modal from './Modal';
import MvpFaceTextureModal from "./MvpFaceTextureModal";



export class MvpBaseballPlayerTable extends Component {

    constructor(props) {
        super(props);
        this.state = { data: [], loading: true,editPlayer: false,showCyberface: false,rowData:[],images:[],faceCount:'unknown',portraitCount:'unknown' };
    
        this.playerAssignColumns = [
            {
                accessor: 'position',
                Header: 'Position',
                width: 200,
            },
           
            {
            accessor: 'firstName',
            Header: 'First Name',
            defaultCanSort:true
        }, 
        {
            accessor: 'lastName',
            Header: 'Last Name ',
            defaultCanSort:true
        }, 
        {
            accessor: 'teamName',
            Header: 'Team',
            defaultCanSort:true
        }, 
        {
            accessor: 'audioPhoto',
            Header: 'Portrait/Audio Number',
        }, 
        {
            accessor: 'faceNumber',
            Header: 'Face Texture Number',
        }, 
       {
            accessor: '',
            Header: 'Edit',
            Cell: ({ cell }) => (
                <button className ="btn-primary" onClick={e=> this.handleEdit(cell)}>
                    Edit
                </button>
                )
        },
           
      ];
   }

    componentDidMount() {
        this.getPlayerAssignments();
    }

    handleEdit = (cell) => {
        console.log(cell?.row?.original);
        this.setState({ editPlayer: true,rowData:cell?.row?.original });
    }

    handleCyberface = (cell) => {

        this.getCyberfacePics(cell?.row?.original);
        this.setState({ showCyberface: true,rowData:cell?.row?.original });
    }

    showModal = e => {
        this.setState({
          editPlayer: !this.state.editPlayer
        });
      };

    showCyberface = e => {
        this.setState({
            showCyberface: !this.state.showCyberface,
            images:[]
        });
    };


    static renderAssignmentTable(playerRecords,playerAssignColumns,faceCount,portraitCount) {
        return (
            <div>
                <h2>Player Assignments</h2>
                <h3>Available Cyberfaces:&ensp;{faceCount}</h3>
                <h3>Available Portraits:&ensp;{portraitCount}</h3>
                <MvpAssignmentTable columns={playerAssignColumns} data={playerRecords} />
                 <br/>
                </div>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : MvpBaseballPlayerTable.renderAssignmentTable(this.state.data, this.playerAssignColumns,this.state.faceCount,this.state.portraitCount);

            

        return (
            <div>
                {contents}
                <Modal onClose={this.showModal} isOpen={this.state.editPlayer} playerData={this.state.rowData} />
                <MvpFaceTextureModal onClose={this.showCyberface} isOpen={this.state.showCyberface} playerData={this.state.rowData} playerImages={this.state.images} />
            </div>
        );
    }

    async getPlayerAssignments() {
        const response = await fetch('mvpbaseball');
        const results = await response.json();
        console.log(results);
        this.setState({ data: results});
        const faceCountResponse = await fetch('mvpbaseball/facecount');
        const faceCount = await faceCountResponse.json();

        const portraitCountResponse = await fetch('mvpbaseball/portraitcount');
        const portraitCount = await portraitCountResponse.json();
        this.setState({ faceCount: faceCount, portraitCount: portraitCount,  loading: false });
    }

    async getCyberfacePics(playerData) {
        
        console.log("method did run");
        console.log(playerData);
        const response = await fetch(`mvpbaseballcyberface/?faceNumber=${playerData.faceNumber}`);
        const results = await response.json();
        console.log(results);
        this.setState({ images: results});
    }
}